import { render, staticRenderFns } from "./CurrentPlan.vue?vue&type=template&id=29875a97&scoped=true"
import script from "./CurrentPlan.vue?vue&type=script&lang=ts"
export * from "./CurrentPlan.vue?vue&type=script&lang=ts"
import style0 from "./CurrentPlan.vue?vue&type=style&index=0&id=29875a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29875a97",
  null
  
)

export default component.exports